import React from "react";
import { UI_STYLES } from "@/styles/uiStyles";
import SvgIcon from "@/components/ui/SvgIcon";
import { UserInfoDomain } from "@/types/UserInfo";  
import { UserSubscriptionDomain } from "@/types/UserSubscription";
import { useSafariPadding } from "@/hooks/useSafaryPadding";
import backIcon from "@/assets/img/icons/Back.svg";   

interface ProfileModalContentProps {
  onLogout: () => void;
  onDelete: () => void;
  onBack: () => void;
  userInfo: UserInfoDomain | null;
  subscription: UserSubscriptionDomain | null;
  navigateToSubscription: () => void;
}

const ProfileModalContent: React.FC<ProfileModalContentProps> = ({ onLogout, onDelete, onBack, userInfo, subscription, navigateToSubscription }) => {

  const subscriptionText = subscription?.isSubscribed ? "Платная до: " + subscription.endDate?.toLocaleDateString() : "Бесплатная";
  const paddingBottom = useSafariPadding();
  return (
    <div className="w-full max-w-md p-0 text-white h-full"
    
    style={{
      paddingBottom: `max(calc(env(safe-area-inset-bottom, 0px)), ${paddingBottom}px)`,
    }}
    > 
      <div className="text-lg font-bold px-3 pt-6 pb-4 flex items-center justify-start">
        <button
          className="w-10 h-10 flex items-center justify-center rounded-full hover:bg-white/10 transition flex-shrink-0"
          onClick={() => onBack()}
          aria-label="Назад"
          type="button"
        >
          <SvgIcon
            src={backIcon}
            className="w-6 h-6"
            color="#ffffff"
            size={24}
          />
        </button>
        Профиль
      </div>
      <div className="text-left px-6 py-3 text-base font-normal">Имя: <span className="text-base font-normal">{userInfo?.name}</span></div>
      <div className="text-left px-6 py-3 text-base font-normal">Тип подписки: <span className="text-base font-normal">{subscriptionText}</span></div>
      <div className="text-left px-6 py-3 text-base font-normal">Почта: <span className="text-base font-normal">{userInfo?.email}</span></div>
      <div className="text-left px-6 py-3 text-base font-normal">Дата рождения: <span className="text-base font-normal">{userInfo?.birthday?.toLocaleDateString("ru-RU")}</span></div>
      <div className="flex flex-col gap-2 justify-center items-center gap-3 pt-3 pb-3">
      <button className={`text-left px-6 py-3 text-base font-normal pt-2 pb-2 min-w-[200px] text-center  border-white/30 rounded-xl ${UI_STYLES.buttonGradient}`} onClick={navigateToSubscription}>Перейти на экран подписки</button>
        <button className={`text-left px-6 py-3 text-base font-normal pt-2 pb-2 min-w-[200px] text-center  border-white/30 rounded-xl ${UI_STYLES.buttonGradient}`} onClick={onLogout}>Выйти из аккаунта</button>
        <button className="text-left px-6 py-3 text-base font-normal pt-2 pb-2 min-w-[200px] text-center border-white/30 rounded-xl bg-red-500" onClick={onDelete}>Удалить аккаунт</button>
      </div>
    </div>
  );
};

export default ProfileModalContent; 
